import loadable from "@loadable/component";

export const components = {
    'Add Forum': loadable(() => import('./AddForum')),
    'Add New Project': loadable(() => import('./AddNewProject')),
    'Add New Task': loadable(() => import('./AddNewTask')),
    'Add New Module': loadable(() => import('./AddNewModule')),
    'Add New Quota': loadable(() => import('./AddNewQuota')),
    'Add Post': loadable(() => import('./AddPost')),
    'Add Scorecard': loadable(() => import('./AddScorecard')),
    'Advanced Edit': loadable(() => import('./Assign/AdvancedEdit')),
    'Assign Scorecard': loadable(() => import('./AddScorecard')),
    'Assign ScoreCard': loadable(() => import('./Assign/ScoreCard')), // Different component for ScoreCard assignment
    'Assign ToDo': loadable(() => import('./Assign/ToDo')),
    'Assign Training': loadable(() => import('./Assign/Training')),
    'Attach Library': loadable(() => import('./Assign/Attach')),
    'Duplicate Module': loadable(() => import('./DuplicateModule')),
    'Edit Blog Post': loadable(() => import('./EditBlogPost')),
    'Edit Task': loadable(() => import('./EditTask')),
    'Premium Media View': loadable(() => import('./PremiumMediaView')),
    'Quick Assign': loadable(() => import('./Assign/QuickAssign')),
    'Quick Edit': loadable(() => import('./Assign/QuickEdit')),
    'Reset Password': loadable(() => import('./ResetPassword')),
    'Save Actuals': loadable(() => import('./SaveActuals')),
    'Save Daily Actuals': loadable(() => import('./SaveDailyActuals')),
    'Scorecard Detail': loadable(() => import('./ScorecardDetail')),
    'Search Topic': loadable(() => import('./SearchTopic')),
    'Task Detail': loadable(() => import('./TaskDetail')),
    'Upload Background Image': loadable(() => import('./UploadBackgroundImage')),
    'Upload Vendor Avatar': loadable(() => import('./UploadVendorAvatar')),
    AddCategory: loadable(() => import('./AddCategory')),
    AddHabit: loadable(() => import('./AddHabit')),
    Assign: loadable(() => import('./Assign')),
    Authentication: loadable(() => import('./Authentication')),
    Company: loadable(() => import('./Company')),
    Confirm: loadable(() => import('./Confirm')),
    CTA: loadable(() => import('./CTA')),
    Preview: loadable(() => import('./Preview')),
    Success: loadable(() => import('./Success')),
    // Note: Many modal components have been temporarily commented out
    // because they don't exist in the current file structure.
    // Uncomment and add them back as needed when the components are created.
};

export const modalComponent = (type) => {
    // Handle compound modal types (e.g., "Assign ScoreCard - Confirm")
    if (type && type.includes(' - Confirm')) {
        return components['Confirm'];
    }
    
    // Handle compound modal types for library attachment
    if (type && type.includes(' - Attach Library')) {
        return components['Attach Library'];
    }
    
    const component = components[type] || null;
    
    if (!component) {
        console.warn(`Modal component "${type}" not found`);
        return null;
    }

    return component;
};